const registerReportConfigureScheduleForm = () => {
  $(function () {
    const remindersOptions = [1, 2, 3];
    const remindersHiddenInput = $('#id_reminders');
    const hourInput = $('#id_hour');
    const frequencyInput = $('input[name="frequency"]');
    const weeklyInput = $('input[name="weekday_weekly"]');
    const biweeklyInput = $('input[name="weekday_biweekly"]');
    const dayOfMonthInput = $('input[name="day_of_month"]');
    const formHiddenFieldClass = 'report__field--hidden';
    const monthlyMsgs = $('#report-monthly-msgs');
    const monthlyGeneralMsg = $('#report-monthly-general-msg');
    const monthlyExceedMsg = $('#report-monthly-exceed-msg');
    const dailyMsgs = $('#report-daily-msgs');
    const dailyGeneralMsg = $('#report-daily-general-msg');

    let lastChosenMonthDay = dayOfMonthInput.parent().dropdown('get value');

    const getRemindersButton = optionID => $(`#report-schedule-frequency-${optionID}`);
    const getRemindersInfo = optionID => $(`#report-reminders-info-${optionID}`);

    const getInputField = (input) => input.parent().parent();

    const setHiddenRemindersInputValue = optionID => remindersHiddenInput.val(optionID);

    const initFields = () => {
      const fieldsWithError = $('.error');
      const lastSelectedRemindersOption = $('input[name="reminders"]').val() || 1;

      getRemindersButton(lastSelectedRemindersOption).trigger('click').addClass('active');
      getRemindersInfo(lastSelectedRemindersOption).show();
      fieldsWithError.removeClass(formHiddenFieldClass);
    };

    const setActiveToClickedButton = (id) => {
      getRemindersButton(id).addClass('active');
      getRemindersInfo(id).show();

      const otherReminderIDs = remindersOptions.filter(otherID => otherID !== id);
      otherReminderIDs.forEach((otherID) => {
        getRemindersButton(otherID).removeClass('active');
        getRemindersInfo(otherID).hide();
      });
    };

    const setupRemindersButtons = () => {
      remindersOptions.forEach((optionID) => {
        getRemindersButton(optionID).on('click', function () {
          if (!$(this).hasClass('disabled')) {
            setHiddenRemindersInputValue(optionID);
            setActiveToClickedButton(optionID);
          }
        });
      });
    };

    const setupTimePicker = () => {
      hourInput.closest('.field').calendar({
        type: 'time',
        ampm: true,
      });
      hourInput.siblings('i').addClass('clock');
      hourInput.prop('autocomplete', 'off');
    };

    const setupClosingMsgs = () => {
      $('.message .close')
        .on('click', function () {
          $(this)
            .closest('.message')
            .transition('fade')
          ;
        });
    };

    const setupCheckingMonthDayExceedance = () => {
      dayOfMonthInput.parent().dropdown({
        onChange: handleSelectedMonthDay,
      });
    };

    const handleSelectedMonthDay = (value = lastChosenMonthDay) => {
      if (value >= 29) {
        monthlyExceedMsg.show();
        monthlyExceedMsg.removeClass('hidden');
      } else {
        monthlyExceedMsg.hide();
      }

      lastChosenMonthDay = value;
    };

    const lockRemindersInputToFirstOption = () => {
      getRemindersButton(1).trigger('click').addClass('active');
      getRemindersButton(2).addClass('disabled');
      getRemindersButton(3).addClass('disabled');
    };

    const unlockRemindersInputToFirstOption = () => {
      getRemindersButton(2).removeClass('disabled');
      getRemindersButton(3).removeClass('disabled');
    };

    const updateFrequencyInputs = (text) => {
      if (text === 'daily (business days)') {
        getInputField(weeklyInput).addClass(formHiddenFieldClass);
        getInputField(biweeklyInput).addClass(formHiddenFieldClass);
        getInputField(dayOfMonthInput).addClass(formHiddenFieldClass);
        lockRemindersInputToFirstOption();
        monthlyMsgs.hide();
        dailyMsgs.show();
        dailyGeneralMsg.removeClass('hidden');
      }

      if (text === 'weekly') {
        getInputField(weeklyInput).removeClass(formHiddenFieldClass);
        getInputField(biweeklyInput).addClass(formHiddenFieldClass);
        getInputField(dayOfMonthInput).addClass(formHiddenFieldClass);
        unlockRemindersInputToFirstOption();
        monthlyMsgs.hide();
        dailyMsgs.hide();
      }

      if (text === 'bi-weekly') {
        getInputField(weeklyInput).addClass(formHiddenFieldClass);
        getInputField(biweeklyInput).removeClass(formHiddenFieldClass);
        getInputField(dayOfMonthInput).addClass(formHiddenFieldClass);
        unlockRemindersInputToFirstOption();
        monthlyMsgs.hide();
        dailyMsgs.hide();
      }

      if (text === 'monthly') {
        getInputField(weeklyInput).addClass(formHiddenFieldClass);
        getInputField(biweeklyInput).addClass(formHiddenFieldClass);
        getInputField(dayOfMonthInput).removeClass(formHiddenFieldClass);
        unlockRemindersInputToFirstOption();
        handleSelectedMonthDay();
        monthlyMsgs.show();
        monthlyGeneralMsg.removeClass('hidden');
        dailyMsgs.hide();
      }
    };

    const setupFrequencyInputHandler = () => {
      frequencyInput.parent().dropdown({
        onChange: (_, text) => updateFrequencyInputs(text)
      });
    };

    const setupFrequencyInputs = () => {
      const freqDropdownText = frequencyInput.parent().dropdown('get text');
      updateFrequencyInputs(freqDropdownText);
    };

    initFields();
    setupRemindersButtons();
    setupTimePicker();
    setupFrequencyInputs();
    setupFrequencyInputHandler();
    setupClosingMsgs();
    setupCheckingMonthDayExceedance();
  });
};

window.registerReportConfigureScheduleForm = registerReportConfigureScheduleForm;
